import styled from "styled-components";
import { getHexOpacity } from "../../../../../../../../../utils/pipes";

export const PatientBarriersModal = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.5)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    overflow: hidden;
    height: 90%;
    z-index: 200;
    padding: 40px 120px;
    background-color: #efeff9;
    width: 100%;
    margin: auto 0 0 0;
    box-sizing: border-box;
    border-radius: 14px;
    justify-content: end;
    display: flex;
    flex-direction: column;
    position: relative;
    &__reaction {
      width: 100%;
      margin: auto;
    }
  }

  .bg-plants-left {
    position: absolute;
    left: 0;
    top: 50px;
    opacity: 0.15;
    pointer-events: none;
    z-index: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  z-index: 1;

  .close-btn {
    width: 36px;
    height: 36px;
    background-color: #ffffff;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 15px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);

    i {
      font-size: 10px;
      color: #16158a;
      font-style: normal;
    }
  }

  .title {
    font-size: 25px;
    font-family: "Nunito Sans Light";
    margin: 0;
    color: #1f1f52;
  }
`;

export const Body = styled.div`
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  .body-top {
    flex: 1;
    overflow: hidden;
    z-index: 1;
    gap: 40px;
    display: flex;
  }
  .body-bottom {
    display: flex;
  }
`;

export const LeftPanel = styled.div`
  flex: 0 0 340px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  .patient-card {
    flex: 1;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
    overflow: auto;
    &__info {
      overflow: auto;
      margin-left: 25px;
    }
  }

  .patient-header {
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 35px 25px 20px 25px;

    img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      object-fit: cover;
    }

    .info {
      .title {
        margin: 0;
        font-size: 25px;
        color: #1f1f52;
        font-family: "Nunito Sans Light";
      }
      .phase {
        font-family: "Nunito Sans Light";
        font-size: 18px;
        color: #1f1f52;
      }
      .tag {
        display: inline-block;
        background: #efeff9;
        color: #1f1f52;
        font-size: 12px;
        padding: 2px 4px;
        border-radius: 5px;
        margin-top: 5px;
      }
    }
  }

  .divider {
    height: 1px;
    background: #cfd3dd;
    margin: 20px 25px;
  }

  .contact-info {
    padding-bottom: 20px;
    font-size: 13px;
    color: #6b6b6b;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-bottom: 1px solid #cfd3dd;
    .contact-row {
      display: flex;
      justify-content: space-between;

      span:last-child {
        font-weight: 500;
        color: #4a4a4a;
      }
    }
  }

  .risk {
    margin-top: 20px;
    font-size: 14px;
    color: #00a600;
    font-weight: 600;
  }

  .points-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .points {
      font-size: 25px;
      color: #707582;
      font-family: "Nunito Sans Light";
    }

    .learn-more {
      background: #f0f0ff;
      color: #16158a;
      border: none;
      border-radius: 15px;
      padding: 8px 18px;
      font-size: 12px;
      cursor: pointer;
      font-weight: 500;
      transition: all 0.2s;

      &:hover {
        background: #e8ebfe;
      }
    }
  }

  .description {
    margin: 25px 0;
    font-size: 14px;
    color: #3e3e5b;
  }

  .journey-card {
    background: #ffffff;
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.2s;
    margin-bottom: 20px;

    &:hover {
      box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.05);
    }

    .journey-header {
      display: flex;
      align-items: center;
      color: #3e3e5b;
      font-weight: 600;
      font-size: 17px;
      margin-bottom: 10px;

      i {
        font-style: normal;
        font-size: 15px;
      }
      .icon-arrow {
        font-size: 23px;
        color: #707582;
        margin-left: auto;
      }
    }

    .journey-desc {
      font-size: 17px;
      color: #3e3e5b;
    }
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .filters-row {
    display: flex;
    align-items: center;
    gap: 15px;
    padding-bottom: 20px;
    border-bottom: 1px solid #cfd3dd;
    justify-content: space-between;
    .select-box,
    .search-box {
    }
  }

  .barriers-list {
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 15px;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #e0e0e0;
      border-radius: 4px;
    }
  }

  .barrier-item {
    background: #ffffff;
    border-radius: 20px;
    padding: 15px 10px;
    display: flex;
    gap: 20px;
    border: 1px solid transparent;
    transition: all 0.2s;

    &:hover {
      border: 1px solid #7582e0;
      box-shadow: 0px 4px 12px rgba(117, 130, 224, 0.1);
    }

    .check-icon {
      align-content: center;
      .icon-check {
        font-size: 11px;
      }
      i {
        font-size: 15px;
        color: #c2c2c2;
        font-style: normal;
      }
    }

    .barrier-info {
      flex: 1;

      h4 {
        margin: 0;
        font-size: 14px;
        color: #1f1f52;
        font-weight: 500;
      }

      p {
        margin: 0;
        font-size: 14px;
        color: #707582;
      }

      .meta {
        display: flex;
        gap: 5px;
        font-size: 13px;
        color: #707582;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        .meta-item {
          display: flex;
          align-items: center;
          gap: 8px;

          i {
            font-size: 15px;
            font-style: normal;
            color: #cfd3dd;
          }

          .meta-item-icon-calendar {
            font-size: 13px;
          }
          .meta-item-icon-location {
            font-size: 15px;
          }

          strong {
            color: #1f1f52;
            font-weight: 400;
          }
        }
      }
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #e9e9f5;
  border-radius: 16px;
  padding: 10px 20px;
  width: 100%;
  border: 2px solid #ffffff;
  font-family: "Nunito Sans Light";
  .toggle-resolved {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 17px;
    color: #1f1f52;
    background: #ffffff;
    padding: 8px 15px;
    border-radius: 14px;
    cursor: pointer;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.02);

    .toggle-switch {
      width: 36px;
      height: 20px;
      background: #f0f0ff;
      border-radius: 10px;
      position: relative;
      transition: background 0.3s;

      &::after {
        content: "";
        position: absolute;
        width: 14px;
        height: 14px;
        background: #ffffff;
        border-radius: 50%;
        top: 3px;
        left: 3px;
        transition: 0.2s;
      }
    }

    &.active .toggle-switch {
      background: #6c6bf5;
      &::after {
        box-shadow: 0px 0px 5px 0px #ffffff;
        transform: translateX(16px);
      }
    }
  }

  .register-btn {
    background: #2533b8;
    color: #ffffff;
    border: none;
    border-radius: 25px;
    padding: 12px 30px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    box-shadow: 0px 4px 12px rgba(37, 51, 184, 0.2);
    transition: all 0.2s;

    &:hover {
      background: #1d2a9b;
    }
  }
`;
